<dynamic-form
  *ngIf="isOk"
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="selectedModel"
  reportName="HrmPersonnel"
  pathPreFix="HRM"
  (cancelChange)="cancel()"
  [columns]="columns"
  (submitChange)="save()">
  <ng-container class="content">
    <ssg-tabset class="tabcontainer tabcontentbox">
      <ssg-tab *ngIf="isOk && orignalColumns && orignalColumns.length > 0">
        <kgrid
          [dataList]="model.HrmLoanDeducts"
          [label]="label"
          [name]="apiName"
          [isMulti]="false"
          [isAdd]="true"
          [isEdit]="true"
          [isDelete]="true"
          [isModal]="true"
          [noToolBar]="true"
          [columns]="orignalColumns"
          pathPreFix="HRM"
          [disableOnDoubleClick]="true"
          (onCreate)="onCreate($event)"
          (onRowSelected)="onEdit($event)"
          (onDoubleClick)="onEdit($event)">
        </kgrid>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
